import { render, staticRenderFns } from "./Canais.vue?vue&type=template&id=74057f5b&scoped=true&"
import script from "./Canais.vue?vue&type=script&lang=js&"
export * from "./Canais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74057f5b",
  null
  
)

export default component.exports